<!--suppress HtmlUnknownTag -->
<template>
    <div style="width: 100%;height: 100%;display: flex;justify-content: center;flex-direction: column;align-items: center">
        <span style="font-size: 40px;">您访问的页面不存在哦</span>
        <img :src="$store.state.backendHost + '/file/empty.png'" width="300px" alt="" ondragstart="return false">
    </div>
</template>

<script>
export default {
    name: "Self",

    data(){
        return{
        }
    },
    
    methods:{
    },
    mounted() {
        this.$message.info("您访问的页面不存在哦！")
    }
}
</script>

<style scoped>

</style>